
export const useLayoutOpts = () => {

  const { isAdmin } = useAuth();

  const fluidLayout = useState<boolean>('fluid-layout', () => false);
  const showFooter = useState<boolean>('show-footer', () => true);
  const adminViewEnabled = useState<boolean>('admin-view-enabled', () => isAdmin.value);

  return {
    fluidLayout,
    showFooter,
    enableAdminView: () => {
      adminViewEnabled.value = true;
    },
    disableAdminView: () => {
      adminViewEnabled.value = false;
    },
    isAdminViewEnabled: computed(() => isAdmin.value && adminViewEnabled.value),
  };
};
